import { REPORT_MESSAGES } from '../../constants/reportMessages';

interface ReportErrorPanelProps {
    error: Error;
    onRetry: () => void;
}

export function ReportErrorPanel({ error, onRetry }: ReportErrorPanelProps) {
    return (
        <div className="text-center py-12">
            <div
                role="alert"
                aria-labelledby="report-error-title"
                className="max-w-md mx-auto rounded-lg border border-red-600 bg-gray-900 p-6 shadow-xl"
            >
                <div className="flex justify-center mb-4">
                    <div className="w-12 h-12 rounded-full bg-red-600/20 flex items-center justify-center">
                        <svg className="w-6 h-6 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.996-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
                        </svg>
                    </div>
                </div>
                <h2 id="report-error-title" className="text-lg font-semibold text-white mb-2">
                    {REPORT_MESSAGES.ERROR.FETCH_FAILED}
                </h2>
                <p className="text-gray-300 mb-6">
                    {error.message}
                </p>
                <button
                    onClick={onRetry}
                    className="inline-flex items-center px-6 py-3 border border-transparent text-sm font-medium rounded-lg shadow-sm text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 focus:ring-offset-gray-900 transition-all duration-200 hover:shadow-lg"
                >
                    <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                    </svg>
                    {REPORT_MESSAGES.ERROR.RETRY}
                </button>
            </div>
        </div>
    );
}